import React from 'react';
import styled from 'styled-components';

const EventsWrapper = styled.div`
  width: 950px;
  margin: auto;
  padding: 32px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @media (max-width: 667px) {
    width: 100%;
    padding: 24px 16px;
    justify-content: center;
  }
`;

export default function Changelog() {
  return (
    <EventsWrapper>
      <section>
        <h4>14.10.2019</h4>

        <ul>
          <li>Replaced text counter by fancy progress bar</li>
          <li>Added "Hide collected ships" mode</li>
        </ul>
      </section>

      <section>
        <h4>02.06.2019</h4>

        <ul>
          <li>Added Lena, Clevelad and Li'l Sandy to the pool</li>
          <li>Added "There Comes the Future Star" event banner</li>
          <li>Added cube tracker to "Scherzo of Iron and Blood" and all supported future events</li>
        </ul>
      </section>
    </EventsWrapper>
  );
}
